export function isDisabled(value) {
  return !value.automation_hub_enabled || !value.automations.length
}
